import { db } from "@/firebase";
import ContractRequestStorage from "@/services/storage/ContractRequestStorage";

const projectContractRef = db.collection("project_contracts");
const REQUESTS_REF = "requests";
const CUSTOM_ANCHORS_VALUES_REF = "custom_anchors_values";

async function createContract(contract) {
    try {
        const createdAt = new Date()
        const result = await projectContractRef.add({...contract,createdAt});

        await result.update({ id_doc: result.id });

        return result.id;
    } catch (err) {
        console.error("Erro ao criar contrato:", err);
        throw err;
    }
}
async function getContractById(id) {
    try {
        const docRef = projectContractRef.doc(id);
        const response = await docRef.get();

        if (!response.exists) {
            throw new Error("Contrato não encontrado");
        }

        return {
            ...response.data(),
            requests: await getRequestsByContractId(docRef),
            customAnchorsValues: await getCustomAnchorsByContractId(docRef)
        };
    } catch (err) {
        console.error("Erro ao buscar contrato pelo id_doc:", err);
        throw err;
    }
}
async function updateContractById(id, contractData) {
    try {

        const {customAnchors, ...contractDataToUpdate } = contractData;

        const docRef = projectContractRef.doc(id);
        await docRef.update({...contractDataToUpdate, updatedAt: new Date()});

        if (customAnchors) {
            await clearCustomAnchors(id);
            await updateCustomAnchors(id, customAnchors);
        }

        return { id, ...contractData };
    } catch (err) {
        console.error("Erro ao atualizar contrato pelo id_doc:", err);
        throw err;
    }
  }

async function createRequestContractById(idContract, currentContract) {
    try {
        const currentAttachedContractFile = currentContract.currentAttachedContractFile;
        delete currentContract.currentAttachedContractFile;

        const docRef = projectContractRef.doc(idContract);
        const ref = await docRef.collection(REQUESTS_REF).add({
            ...currentContract,
            createdAt: new Date().getTime(),
            updatedAt: new Date().getTime()
        });

        const filePath = await ContractRequestStorage.uploadFile(idContract, currentAttachedContractFile);

        await ref.update({
            id_doc: ref.id,
            currentAttachedContract: {
                name: currentAttachedContractFile.name,
                path: filePath,
            }
        });

        // Get updated contract data
        const refSnap = await ref.get();
        const updatedData = refSnap.data();
        
        // Get historic data (may be empty for new contracts)
        const historicSnapshot = await ref.collection('historic').orderBy("archivedAt", "desc").get();
        const historic = historicSnapshot.docs.map(historicDoc => ({
            id_doc: historicDoc.id,
            ...historicDoc.data(),
        }));
        
        // Return contract with historic data
        return {
            ...updatedData,
            historic
        };
    } catch (err) {
        console.error("createRequestContractById:", err);
    }
}

async function updateRequestContractById(idContract, initialContract, currentContract) {
    try {
        const docRef = projectContractRef.doc(idContract);
        const requestRef = docRef.collection(REQUESTS_REF).doc(currentContract.id_doc);        
            
            delete currentContract.historic;
        
            // 1. Upload new file
            const currentAttachedContractFile = currentContract.currentAttachedContractFile;
            delete currentContract.currentAttachedContractFile;
            const filePath = await ContractRequestStorage.uploadFile(idContract, currentAttachedContractFile);

            // 2. Move initial contract to historic
            await requestRef.collection('historic').add({
                ...initialContract.currentAttachedContract,
                createdAt: currentContract.updatedAt,
                archivedAt: new Date().getTime(),
                id_doc: await requestRef.collection('historic').doc().id
            });

            // 3. Update current contract with new file
            currentContract.currentAttachedContract = {
                name: currentAttachedContractFile.name,
                path: filePath,
            };

            // Update request with new data
            await requestRef.update({
                ...currentContract,
                updatedAt: new Date().getTime()
            });

            // Get updated contract data
            const updatedSnap = await requestRef.get();
            const updatedData = updatedSnap.data();
            
            // Get fresh historic data
            const historicSnapshot = await requestRef.collection('historic').orderBy("archivedAt", "desc").get();
            const historic = historicSnapshot.docs.map(historicDoc => ({
                id_doc: historicDoc.id,
                ...historicDoc.data(),
            }));
            
            // Return contract with updated historic data
            return {
                ...updatedData,
                historic
            };
    } catch (err) {
        console.error("updateRequestContractById:", err);
    }
}
async function deleteRequestsByContractIdAndRequest(id, request) {
    try {
        const subcollectionRef = projectContractRef.doc(id).collection(REQUESTS_REF);

        const docRef = subcollectionRef.doc(request.id_doc);

        await docRef.delete();
    } catch (err) {
        console.error(`Erro ao excluir request ${request.id_doc} do contrato ${id}:`, err);
        throw err;
    }
  }
async function getRequestsByContractId(docRef) {
    const subcollectionSnapshotRequests = await docRef.collection(REQUESTS_REF).orderBy("createdAt", "desc").get();
    
    // Get all requests with their data
    const requests = await Promise.all(subcollectionSnapshotRequests.docs.map(async (doc) => {
        const requestData = {
            id_doc: doc.id,
            ...doc.data(),
        };
        
        // Get historic data for this request
        const historicSnapshot = await doc.ref.collection('historic').orderBy("archivedAt", "desc").get();
        const historic = historicSnapshot.docs.map(historicDoc => ({
            id_doc: historicDoc.id,
            ...historicDoc.data(),
        }));
        
        // Add historic array to the request data
        return {
            ...requestData,
            historic: historic
        };
    }));
    
    return requests;
}

async function clearCustomAnchors(id) {
    try {
        const customAnchorsCollectionRef = projectContractRef.doc(id).collection(CUSTOM_ANCHORS_VALUES_REF);
        const snapshot = await customAnchorsCollectionRef.get();

        const batch = db.batch();

        snapshot.docs.forEach((doc) => {
            batch.delete(doc.ref);
        })

        await batch.commit();
    } catch (err) {
        console.error("Erro ao limpar subcoleção custom_anchors_values:", err);
        throw err;
    }
}
async function updateCustomAnchors(id, anchorsData) {
    try {
        const customAnchorsCollectionRef = projectContractRef.doc(id).collection(CUSTOM_ANCHORS_VALUES_REF);
        const batch = db.batch();

        anchorsData.forEach((anchor) => {
            const anchorDocRef = customAnchorsCollectionRef.doc()

            batch.set(anchorDocRef, {
                id_doc: anchorDocRef.id,
                id_doc_anchor: anchor.id_doc_anchor,
                name: anchor.name,
                value: anchor.value
            })
        })

        await batch.commit();
    } catch (err) {
        console.error("Erro ao atualizar subcoleção custom_anchors_values:", err);
        throw err;
    }
}
async function getCustomAnchorsByContractId(docRef) {
    const subcollectionSnapshotCustomAnchorsValues = await docRef.collection(CUSTOM_ANCHORS_VALUES_REF).get();
    return subcollectionSnapshotCustomAnchorsValues.docs.map((doc) => ({
        id_doc: doc.id,
        ...doc.data(),
    }));
}

export default {
    createContract,
    getContractById,
    updateContractById,
    updateRequestContractById,
    createRequestContractById,
    deleteRequestsByContractIdAndRequest,
};
